import _Router from './Router';

export default _Router;
